import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Popup,
  EditableComponent,
  Loading,
  InputField,
} from 'arteia-js/components';

import { API } from 'arteia-js/services';
import { backgroundArtworks } from '../configs/backgroundArtworks.config';

var artwork =
  backgroundArtworks[Math.floor(Math.random() * backgroundArtworks.length)];
class UpdatePassword extends EditableComponent {
  state = {
    updateErrored: false,
    updating: false,
    updateSuccessful: false,
    errorMessage: '',
    passwordA: '',
    passwordB: '',
    blockButton: false,
  };

  updatePassword = () => {
    const { passwordA: password } = this.state;

    const { match, history } = this.props;

    this.setState({
      updating: true,
    });

    API.post('/update-password', {
      password,
      changePasswordId: match.params.changePasswordId,
    })
      .then(() => {
        this.setState({
          updating: false,
          updateSuccessful: true,
        });

        setTimeout(() => {
          history.push('/login');
        }, 1500);
      })
      .catch((err) => {
        const { status = 500 } = err;
        const errors = {
          404: 'Your link has expired.',
          500: 'Something went wrong. Try again in few minutes.',
        };
        this.setState({
          updating: false,
          updateErrored: true,
          errorMessage: errors[status],
          blockButton: status === 404,
        });
        if (status === 404) {
          setTimeout(() => {
            history.push('/forgot-password');
          }, 1500);
        }
      });
  };

  render() {
    const {
      updateSuccessful,
      updateErrored,
      updating,
      errorMessage,
      passwordA,
      passwordB,
      blockButton,
    } = this.state;

    const inputsFilled = passwordA.length !== 0 && passwordB.length !== 0;

    const strongPassword =
      passwordA.length === 0 ||
      (passwordA.length > 5 &&
        /\d/.test(passwordA) &&
        /[a-zA-Z]/.test(passwordA));

    const passwordsSame = passwordA === passwordB || passwordB.length === 0;

    const allowSave =
      inputsFilled && strongPassword && passwordsSame && !blockButton;

    return (
      <div
        className='forgot-password-wrapper'
        style={{ backgroundImage: `url(${artwork.asset})` }}
      >
        <div className='artwork-details'>
          <span className='artist-name'>{artwork.artistName}</span>
          <br />
          <span className='artwork-title'>
            {artwork.title}, {artwork.year}
          </span>
        </div>
        <span className='all-rights-reserved'>
          &copy; {new Date().getFullYear()} Arteïa - All rights reserved
        </span>
        <Popup size='form' noTitle noCloseHandler className='form'>
          <div className='popup-content'>
            <h1>Set a New Password</h1>

            {updating && (
              <div className='text-center'>
                <Loading />
              </div>
            )}

            {!updating && (
              <Fragment>
                <span className='input-label'>Password</span>
                <InputField
                  type={'password'}
                  value={passwordA}
                  onChange={this.onFieldChange('passwordA')}
                />

                <span className='input-label'>Confirm Password</span>
                <InputField
                  type={'password'}
                  value={passwordB}
                  onChange={this.onFieldChange('passwordB')}
                />

                <div className='help-msg'>
                  Password should be at least 8 characters long and contain at
                  least 1 number and 1 letter.
                </div>
                <div className='form-msg'>
                  {updateErrored && (
                    <span className='error-msg'>
                      {updateErrored && errorMessage}
                    </span>
                  )}

                  {!strongPassword && (
                    <span className='error-msg'>
                      Password should be at least 8 characters long and contain
                      at least 1 number and 1 letter.
                    </span>
                  )}

                  {!passwordsSame && (
                    <span className='error-msg'>Passwords do not match</span>
                  )}

                  {!updating && updateSuccessful && (
                    <span className='success-msg'>
                      Password updated. Please{' '}
                      <Link to={'/login'}>login again</Link>.
                    </span>
                  )}
                </div>
              </Fragment>
            )}
            <div className='button-container'>
              <button
                className='art-btn'
                disabled={!allowSave}
                onClick={this.updatePassword}
              >
                Update password
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}

UpdatePassword.propTypes = {};
UpdatePassword.defaultProps = {};

export default UpdatePassword;



// WEBPACK FOOTER //
// ./src/scenes/UpdatePassword/index.js